import React from 'react';
import { Helmet } from 'react-helmet-async';
import SupportQuestions from './SupportQuestions';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import SupportQuestion from './SupportQuestion';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../manage/MobileNavigation';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../dialogs_new/DialogManager';
import SecondaryAction from '../_components/actions/SecondaryAction';
import NoNetworkSelected from '../settings/NoNetworkSelected';
import useNetwork from '../../hooks/useNetwork';
import useEducatorSupportQuestions from '../manage-support-questions/useEducatorSupportQuestions';
import usePartnerSupportQuestions from '../manage-support-questions/usePartnerSupportQuestions';
import Section from '../manage-support-questions/Section';

export default function Layout(props) {
  const router = useRouter();
  const network = useNetwork();

  const educatorSupportQuestions = useEducatorSupportQuestions({});
  const partnerSupportQuestions = usePartnerSupportQuestions({});

  if (!network) {
    return (
      <NoNetworkSelected />
    );
  }

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Settings: Support Questions</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Settings']}
        title="Support Questions"
        description={(
          <>
            This page shows all support questions.
          </>
        )}
      />
      {/*<SupportQuestions router={router}>*/}
      {/*  {function(result) {*/}
      {/*    return (*/}
      {/*      <Results result={result} columns={1} resource="support questions" emptyIcon={QuestionMarkCircleIcon}>*/}
      {/*        {function(supportQuestion, index) {*/}
      {/*          return (*/}
      {/*            <SupportQuestion*/}
      {/*              key={index}*/}
      {/*              supportQuestion={supportQuestion}*/}
      {/*            />*/}
      {/*          );*/}
      {/*        }}*/}
      {/*      </Results>*/}
      {/*    );*/}
      {/*  }}*/}
      {/*</SupportQuestions>*/}
      <div className="space-y-12">
        {educatorSupportQuestions.data.length > 0 && (
          <Section
            title="Educator Questions"
            subtitle="These are questions that will be visible to community members who have joined as an educator."
          >
            <div className="space-y-4">
              {educatorSupportQuestions.data.map(function(supportQuestion) {
                return (
                  <SupportQuestion
                    key={supportQuestion.id}
                    supportQuestion={supportQuestion}
                  />
                );
              })}
            </div>
          </Section>
        )}
        {partnerSupportQuestions.data.length > 0 && (
          <Section
            title="Partner Questions"
            subtitle="These are questions that will be visible to community members who have joined as a partner."
          >
            <div className="space-y-4">
              {partnerSupportQuestions.data.map(function(supportQuestion) {
                return (
                  <SupportQuestion
                    key={supportQuestion.id}
                    supportQuestion={supportQuestion}
                  />
                );
              })}
            </div>
          </Section>
        )}
      </div>
    </div>
  );
}
